
import { Component, Vue } from 'vue-property-decorator'
import {
  getApplicationList,
  applicationConfig,
  modifyApplication,
  switchApplication,
  delApplication
} from '@/api/enterpriseApp/enterpriseApp'
import { UserModule } from '@/store/modules/user'
import { setToken, setType, setAntToken } from '@/utils/cookies'
import addApplication from './components/addApplication.vue'
import editApplication from './components/editApplication.vue'
import { AppModule } from '@/store/modules/app'
import LangSelect from '@/components/LangSelect/index.vue'
import { PermissionModule } from '@/store/modules/permission'

@Component({
  name: 'enterpriseApp',
  components: {
    addApplication,
    editApplication,
    LangSelect
  }
})
export default class extends Vue {
  private listForm: any = {}
  private applicationList: any = []
  private loading: boolean = false
  private configForm: any = {}
  private configApplication: any = {}
  private antApplication: any = {}
  private action: string = ''
  private currentId: number | null = null
  private currenType: string = ''
  private dialogVisible: boolean = false
  private enterpriseLimit: number = 0
  private antLimit: number = 0
  private newToken: any = ''
  private availableCurrency: any = []
  private antCurrency: any = []
  private creator: any = ''
  private antCreator: any = ''

  get isMobileH5() {
    return window.screen.availWidth <= 700 && window.screen.availWidth >= 310
  }
  private dialogVisible1: boolean = false
  private currentDomain: any = ''
  private jumpDoain: string = ''
  private h5Url: any = ''
  private getDoain() {
    this.currentDomain = window.location.host
    this.jumpDoain = this.currentDomain.split('manage.')[1]
    // this.h5Url = 'h5.' + this.jumpDoain
    this.h5Url = `${'h5.' + this.jumpDoain}`
  }
  private jump() {
    window.open('https://' + this.h5Url)
  }

  get language() {
    return AppModule.language
  }

  // 修改当前应用启用/禁用状态
  private async setStatus(item: any) {
    this.loading = true
    const status = item.status === 0 ? 1 : 0
    const data: any = {
      id: item.id,
      status: item.status,
      name: item.name,
      enterprise_type: item.enterprise_type
    }
    try {
      await modifyApplication(data).then((res: any) => {
        this.$message({
          message: 'Save successful!',
          type: 'success'
        })
        this.getApplicationList()
        this.getApplicationConfig()
        this.loading = false
      })
    } catch (e) {
      item.status = status
      this.loading = false
    }
  }

  private flag: boolean = false
  // 按钮只触发一次
  private flagStr() {
    setTimeout(() => {
      this.flag = false
    }, 5000)
  }

  // 点击当前应用,切换应用
  private toPath: any[] = []
  private async currentApplication(item: any) {
    if (item) {
      try {
        this.loading = true
        this.flag = true
        const data = {
          ent_id: item.id,
          enterprise_type: item.enterprise_type
        }
        await switchApplication(data).then((res: any) => {
          this.newToken = res.token
          setType(item.enterprise_type)
          if (res.enterprise_type === 'ant') {
            UserModule.SetAntToken(this.newToken)
            this.$router.push(
              { path: '/' },
              () => {},
              () => {}
            )
            this.loading = false
            this.flagStr()
          } else {
            UserModule.SetToken(this.newToken)
            this.$router.push(
              { path: '/' },
              () => {},
              () => {}
            )
            this.loading = false
            this.flagStr()
          }
        })
      } catch (e) {
        this.loading = false
      }
    }
  }

  // 创建、编辑应用窗口
  private openDialogVisible(action: string, item: any) {
    this.dialogVisible = true
    this.action = action
    if (item) {
      this.currentId = item.id
      this.currenType = item.enterprise_type
    }
  }

  // 关闭窗口
  private closeDialogVisible() {
    this.dialogVisible = false
    this.getApplicationConfig()
    this.getApplicationList()
  }
  // 关闭窗口不调用接口
  private closeDialogVisible1() {
    this.dialogVisible = false
  }

  // 点击按钮

  // 获取应用列表
  private async getApplicationList() {
    try {
      this.loading = true
      const data = {
        ...this.listForm
      }
      await getApplicationList(data).then((res: any) => {
        this.applicationList = res
        this.loading = false
      })
    } catch (e) {
      this.loading = false
    }
  }

  // 获取应用配置
  private async getApplicationConfig() {
    try {
      const data = {
        ...this.configForm
      }
      await applicationConfig(data).then((res: any) => {
        if (res.ant) {
          this.antApplication = res.ant
          this.antLimit = res.ant.config
          this.antCurrency = this.antApplication.available_currency
          this.antCreator = res.ant.current_user
        }
        this.configApplication = res
        this.enterpriseLimit = res.config
        this.availableCurrency = res.available_currency
        this.creator = res.current_user
      })
    } catch (e) {}
  }

  // 删除应用
  private async openDelApp(item: any) {
    this.$confirm('Are you sure to quit it?', {
      confirmButtonText: 'Yes',
      cancelButtonText: 'Cancel',
      type: 'warning',
      callback: action => {
        if (action === 'confirm') {
          this.delApp(item)
        }
      }
    })
  }
  private async delApp(params: any) {
    const data: any = {
      id: params.id,
      status: '2',
      enterprise_type: params.enterprise_type
    }
    await delApplication(data).then(() => {
      this.$message({
        type: 'success',
        message: 'Delete successful!'
      })
      this.getApplicationList()
      this.getApplicationConfig()
    })
  }

  private async logout() {
    await UserModule.LogOut()
    await this.$router.push(`/login`)
  }

  private siteName = this.$store.state.app.enterprise.ssl_switch.site_name
  private systemName: any = 'Admin System'
  private sitelogo: any = this.$store.state.app.enterprise.ssl_switch.site_logo
  private systemLogo: any = ''

  private async init() {
    await this.getApplicationConfig()
    await this.getApplicationList()
    await this.getDoain()
  }

  mounted() {
    this.init()
    if (this.isMobileH5) {
      this.dialogVisible1 = true
    }
    if (this.siteName && this.siteName !== '') {
      AppModule.SetSiteName(this.siteName)
    } else {
      AppModule.SetSiteName(this.systemName)
    }
    if (this.sitelogo && this.sitelogo !== '') {
      AppModule.SetSiteLogo(this.sitelogo)
    } else {
      AppModule.SetSiteLogo(this.systemLogo)
    }
  }
}
